var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 4.202c2.281 1.715 4.456 7.807 5.258 10.639.404 1.33-2.225 1.878-3.741 2.777-1.214.719-1.355 1.347-1.274 1.572.744 3.48 10.476 12.136 15.249 16.03.465.224 1.614.167 2.487-1.859.874-2.025 2.279-2.831 2.872-2.981 2.508 0 7.935 3.675 10.335 5.513-.135 4.159-3.22 11.72-14.48 8.699C13.018 40.814 4.402 26.296.762 16.678c-3.64-9.617 6.775-14.62 9.627-12.476Z",
    fill: "#002A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.474 17.34c-1.74-1.468-3.843-2.267-5.232-2.546l.252-1.427c1.56.313 3.879 1.192 5.824 2.835 1.962 1.655 3.576 4.12 3.576 7.56h-1.361c0-2.887-1.334-4.966-3.059-6.422ZM34.04 11.57c-3.222-2.456-7.035-3.32-9.54-3.356l.021-1.534c2.752.04 6.88.974 10.396 3.653 3.547 2.704 6.429 7.157 6.659 14.112l-1.48.053C39.882 18.02 37.23 14 34.04 11.569Z",
    fill: "#002A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.931 5.448c-4.826-3.343-10.416-4.183-14.067-3.93L23.758.047c3.931-.273 9.882.622 15.041 4.196C43.992 7.839 48.31 14.099 49 24.403l-1.502.097c-.663-9.895-4.774-15.732-9.567-19.052Z",
    fill: "#002A1B"
  })));
};
export default SvgCall;